//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import ValidationTypeTag from '@/components/Projects/Detail/Tabs/SupervisorValidation/ValidationTypeTag.vue'

export default {
  components: { ModalWithTitleBar, ValidationTypeTag },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    collaborator: {
      type: Object,
      default: () => ({}),
    },
    supervisor: {
      type: Object,
      default: () => ({}),
    },
    skillsValidations: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    collaboratorName() {
      return `${this.collaborator.names} ${this.collaborator.lastnames}`
    },
    supervisorName() {
      return `${this.supervisor.names} ${this.supervisor.lastnames}`
    },
  },
  methods: {
    onToggle() {
      this.$emit('toggle')
    },
  },
}
